import React from 'react';
import { ShimmerBox } from '../PageSkeleton/PageSkeleton';

/**
 * Skeleton for table sections with a header bar + action button.
 * Matches: Documents, Notes sub-pages of patient-profile.
 */
const TableSectionSkeleton: React.FC<{
    rows?: number;
    columns?: number;
    showActionButton?: boolean;
}> = ({ rows = 5, columns = 4, showActionButton = true }) => (
    <section
        className="flex h-full flex-col rounded-xl shadow-lg animate-fade-in-up"
        style={{ background: 'var(--v2-bg-card)', borderColor: 'var(--v2-border-subtle)' }}
    >
        {/* Header bar with action */}
        <div
            className="sticky top-0 z-10 border-b px-6 py-4 rounded-t-lg flex items-center justify-between"
            style={{ background: 'var(--v2-bg-surface)', borderColor: 'var(--v2-border-subtle)' }}
        >
            <ShimmerBox className="h-5 w-32 rounded-md" delay="0s" />
            {showActionButton && (
                <ShimmerBox className="h-9 w-36 rounded-lg" delay="0.1s" />
            )}
        </div>

        {/* Table body */}
        <div className="flex-1 px-6 py-4 overflow-hidden">
            {/* Table header row */}
            <div
                className="flex items-center gap-4 px-2 py-2.5 mb-1 border-b"
                style={{ borderColor: 'var(--v2-border-divider)' }}
            >
                {Array.from({ length: columns }).map((_, i) => (
                    <ShimmerBox
                        key={i}
                        className="h-3.5 rounded-md"
                        style={{ width: i === 0 ? '40px' : `${70 + Math.random() * 50}px` }}
                        delay={`${i * 0.04}s`}
                    />
                ))}
            </div>

            {/* Table rows */}
            {Array.from({ length: rows }).map((_, r) => (
                <div
                    key={r}
                    className="flex items-center gap-4 px-2 py-3 border-b last:border-0"
                    style={{ borderColor: 'var(--v2-border-divider)' }}
                >
                    {Array.from({ length: columns }).map((_, c) => (
                        <ShimmerBox
                            key={c}
                            className="h-4 rounded-md"
                            style={{
                                width: c === 0 ? '36px' :
                                    c === 1 ? '140px' :
                                        `${60 + Math.random() * 50}px`,
                            }}
                            delay={`${r * 0.04}s`}
                        />
                    ))}
                </div>
            ))}

            {/* Pagination */}
            <div className="flex justify-end pt-4">
                <div className="flex gap-2">
                    {Array.from({ length: 3 }).map((_, i) => (
                        <ShimmerBox key={i} className="h-8 w-8 rounded-md" delay={`${i * 0.05}s`} />
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default TableSectionSkeleton;
